import type {Component} from "vue";
import DemoApp from "@/DemoApp.vue";
import Loader from "@/components/Loader.vue";
import PalkLogoColor from "@/components/PalkLogoColor.vue";
import LanguageSelection from "@/components/LanguageSelection.vue";
import LoginBanner from "@/features/login-banner/LoginBanner.vue";

type AsyncComponentLoader = () => Promise<Component>;
type ComponentRegistry = Record<string, Component | AsyncComponentLoader>;

class MvcVueIntegration {

    private readonly components: ComponentRegistry = {};

    constructor() {
        this.components = {
            "demo-app": DemoApp,
            "loader": Loader,
            "palk-logo-color": PalkLogoColor,
            "language-selection": LanguageSelection,
            "login-banner": LoginBanner,
            "login-page": () => import("@/features/auth/LoginPage.vue"),
            "image-cropper": () => import("@/components/ImageCropper.vue"),
            "admin-page": () => import("@/views/admin/AdminView.vue"),
            "survicate-component": () => import("@/features/customer-feedback/SurvicateComponent.vue"),
            "auth-binding-section": () => import("@/features/auth-binding/AuthBindingSection.vue")
        };
    }

    getComponents = (): ComponentRegistry => this.components;
}

const mvcVueIntegration = new MvcVueIntegration();
export default mvcVueIntegration;


